import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import Input from 'react-bootstrap/lib/Input';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';

const ChoiceBox = React.createClass({
	mixins: [LinkedStateMixin],

	contextTypes: {
		history: React.PropTypes.object.isRequired
	},

    onClickHandler() {
        this.props.onSelect(this.props.value);
    },

	render() {
		const type = this.props.type;
		const name = this.props.name;
		const value = this.props.value;
		const label = this.props.label || '';
		const labelToRight = this.props.labelToRight || false;
		const add = this.props.add;
		const addClass = this.props.addClass;
        const className = this.props.className;
        const disabled = this.props.disabled;

        console.log("Render");

		return (
			<label className={`choicebox ${labelToRight && 'ltr'} ${className}`} onClick={this.onClickHandler}>
				{this.props.children}
				<input className="choicebox-input" type={type} name={name} value={value} disabled={disabled}/>
				<div className="choicebox-label">
					<span className="choicebox-label-text">{label}</span>
					{add && <span className={`choicebox-label-additional ${addClass}`} dangerouslySetInnerHTML={{__html: add}}></span>}
				</div>
				<div className={'choicer ' + (('choicer--' + type) || '')}></div>
			</label>
		);
	}
});

export default ChoiceBox;


/** WEBPACK FOOTER **
 ** ./src/components/ChoiceBox/ChoiceBox.js
 **/